"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _events = _interopRequireDefault(require("../events"));

var _jsonrpc = require("../jsonrpc");

var _misc = _interopRequireDefault(require("../../helpers/misc"));

var _debug = _interopRequireDefault(require("debug"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var debug = (0, _debug.default)('MEWconnectWeb3');

var _default = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref, res, next) {
    var payload, eventHub, msg;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _ref.payload, eventHub = _ref.eventHub;

            if (!(payload.method !== 'personal_sign')) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", next());

          case 3:
            msg = payload.params[0];
            eventHub.emit(_events.default.SHOW_MSG_CONFIRM_MODAL, msg, function (_response) {
              if (_response.reject) {
                debug('USER DECLINED PERSONAL SIGN');
                res((0, _jsonrpc.toError)(payload.id, 'User Rejected Request', 4001));
                return;
              }

              _response = _misc.default.sanitizeHex(_response.toString('hex'));
              res(null, (0, _jsonrpc.toPayload)(payload.id, _response));
            });

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.default = _default;